import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IFeesFormMeta {
    transactionCode: FormInputMeta;
    date: FormInputMeta;
    PAN: FormInputMeta;
    PANExtension: FormInputMeta;
    BINSource: FormInputMeta;
    BINDestination: FormInputMeta;
    feeId: FormInputMeta;
    feeType: FormInputMeta;
    message: FormInputMeta;
    currency: FormInputMeta;
    amount: FormInputMeta;
    //
    schema: any;
  }

const FeesFormMeta = {} as IFeesFormMeta;

FeesFormMeta.transactionCode = {
  name: 'transactionCode',
  type: 'select',
  label: 'Code transaction',
  options:  [
    {
      label: 'Code transaction A',
      value: 'a'
    },
    {
      label: 'Code transaction B',
      value: 'b'
    },
    {
      label: 'Code transaction C',
      value: 'b'
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};
FeesFormMeta.date = {
  name: 'date',
  type: 'date',
  label: 'Date d\'evenement',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.PAN = {
  name: 'PAN',
  type: 'text',
  label: 'PAN',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.PANExtension = {
  name: 'PANExtension',
  type: 'text',
  label: 'Extension PAN',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.BINSource = {
  name: 'BINSource',
  type: 'text',
  label: 'Source BIN',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.BINDestination = {
  name: 'BINDestination',
  type: 'text',
  label: 'Destination BIN',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.feeId = {
  name: "feeId",
  label: "Id frais",
  type: "select",
  options:  [
      {
        label: 'Id frais A',
        value: 'a'
      },
      {
        label: 'Id frais B',
        value: 'b'
      },
      {
        label: 'Id frais C',
        value: 'b'
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.feeType = {
  name: "feeType",
  label: "Type frais",
  type: "select",
  options:  [
      {
        label: 'Type frais A',
        value: 'a'
      },
      {
        label: 'Type frais B',
        value: 'b'
      },
      {
        label: 'Type frais C',
        value: 'b'
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
};

FeesFormMeta.message = {
  name: 'message',
  type: 'text',
  label: 'Message',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

FeesFormMeta.currency = {
  name: 'currency',
  type: 'text',
  label: 'Devise',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
FeesFormMeta.amount = {
  name: 'amount',
  type: 'text',
  label: 'Montant',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};


FeesFormMeta.schema = yup.object().shape(getValidationSchema(FeesFormMeta));

export default FeesFormMeta;
